import(/* webpackMode: "eager", webpackExports: ["InsurancePage"] */ "/app/src/app/(browse)/insurance/InsurancePage.tsx");
